// extracted by mini-css-extract-plugin
export default {"wrapper":"Graphs_wrapper__KaAXD","controls":"Graphs_controls__MRUTd","graph":"Graphs_graph__dlMDb","graphpadding":"Graphs_graphpadding__oPO8q"};